module.exports = __webpack_public_path__ + "img/5bg@2x.f09760ac.png";